export function checkIfNCSCodeIsValid(ncs: string) {
    if (!ncs) return false;
    const regex = /^(S ?)?(\d{2})(\d{2})-([NYRBG]|([NYRBG]\d{2}[NYRBG]))$/i;
    var regexMatch = ncs.match(regex);
    if (!regexMatch) {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [, , blackness, chromaticness, hue] = regexMatch;

    if (+blackness + +chromaticness > 100) {
        return false;
    }
    return true;
}
